import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'LOGOUT_EVERYWHERE_POST',
  POST_SUCCESS: 'LOGOUT_EVERYWHERE_POST_SUCCESS',
  POST_FAILURE: 'LOGOUT_EVERYWHERE_POST_FAILURE',
};

export const post = actions.post(() => `${BASE_URL}/logout-everywhere/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
